/**
 * authInterceptor
 *
 * Interceptor hooks up to all http requests and plugs authorization header from cached jwt token.
 */

import angular from 'angular';
import PubSub from 'pubsub-js';

const tokenName = 'jwt_token';

const module = angular
  .module('auth.authInterceptor', ['constants', 'config'])
  .factory('authInterceptor', ['$q', 'config', 'topics', 'localService', ($q, config, topics, localService) => {
    return {
      request: (request) => {
        if (request.skipAuthorization || request.url.indexOf(config.relBaseUrlAPi) !== 0) {
          return request;
        }

        let token;
        if (localService.get(tokenName)) {
          token = angular.fromJson(localService.get(tokenName));
        }
        // is token an object?
        if (token === Object(token)) {
          token = token.token;
        }
        if (token) {
          request.headers.Authorization = 'Bearer ' + token;
        }
        return request;
      },
      responseError: (response) => {
        if (response.status === 401) {
          localService.remove(tokenName);
          PubSub.publish(topics.auth.unauthenticated, response);
        }
        if (response.status === 403) {
          PubSub.publish(topics.auth.unauthorized, response);
        }
        PubSub.publish(topics.auth.failed, response);
        return $q.reject(response);
      }
    };
  }])
  .config(['$httpProvider', ($httpProvider) => {
    $httpProvider.interceptors.push('authInterceptor');
  }]);

export default module;



/** WEBPACK FOOTER **
 ** ./client/app/services/auth/authInterceptor.js
 **/